// ShortAd.js
'use strict';
import { connect } from 'react-redux';
import { LRUCache } from 'lru-cache';
import { addBreadcrumb } from '@sentry/browser';

import ShortAd from '../component/ShortAd.jsx';
import fetchOembedData from '../action/fetchOembedData.js';
import setPlayerData from '../action/setPlayerData.js';
import getOperationData from '../selector/getOperationData.js';
import { decodeUnicode } from '../resource/base64Utils.js';
import { SHORT_AD_ID_PREFIX } from '../resource/getIsShortAdId.js';
import { Severity } from '../resource/sentry.js';

const cache = new LRUCache({ max: 256 });
const getAdLink = ({ adId }) => {
  let adLink = cache.get(adId);

  if (!adLink) {
    adLink = decodeURIComponent(
      decodeUnicode({ str: adId?.replace(SHORT_AD_ID_PREFIX, '') })
    );
    addBreadcrumb({
      category: 'ShortAd',
      level: Severity.Debug,
      message: 'get decoded adLink from adId',
      data: {
        adLink,
        adId,
      },
    });

    cache.set(adId, adLink);
  }

  return adLink;
};

const mapStateToProps = (state, { adId }) => {
  const adLink = getAdLink({ adId });
  return {
    adId,
    adLink,
    adData: getOperationData(state, ['oembed'], adLink),
    currentLanguage: getOperationData(state, ['config'], 'language'),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchOembedData: ({ url, language }) =>
      dispatch(fetchOembedData({ url, language })),
    setPlayerData: ({ isMuted }) =>
      dispatch(setPlayerData({ isMuted, isFirstUnmuted: false })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShortAd);
